import {gql} from 'apollo-angular';

export const GET_PRIZE_COMPETITION = gql`
  query GetPrizeCompetition {
    getChampionship {
      competitionName
      startAt
      endAt
      daysLeft
    }
  }
`;
